import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AlertComponent, CustomMissingTranslationHandler } from '@balloon-race-fullstack-monorepo/dbr-common';
import { ENVIRONMENT } from '../environments/environment';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';

/**
 * Create a custom translation loader
 * @param httpClient
 * @returns {TranslateHttpLoader}
 */
export function createTranslateLoader(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, ENVIRONMENT.TRANSLATION_PATH, '.json');
}

/**
 * Factory for CustomMissingTranslationHandler
 *
 * @returns {CustomMissingTranslationHandler}
 */
export function createCustomMissingTranslationHandler() {
  return new CustomMissingTranslationHandler();
}

@Component({
    imports: [RouterModule, TranslateModule, AlertComponent],
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'dbr-app';
  private translateService = inject(TranslateService);

  constructor() {
    this.translateService.setDefaultLang('de');
    this.translateService.use('de');

    registerLocaleData(localeDe);
  }
}
